var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriokzzlohgo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 278,
    height: 146,
    viewBox: "0 0 278 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 42C41 40.8954 41.8954 40 43 40H236C237.105 40 238 40.8954 238 42V100C238 101.105 237.105 102 236 102H43C41.8954 102 41 101.105 41 100V42Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.772 76.48C120.252 76.48 120.708 76.528 121.14 76.624C121.572 76.72 121.932 76.84 122.22 76.984V83.86C121.236 83.452 120.18 83.248 119.052 83.248C117.54 83.248 116.376 83.644 115.56 84.436C114.744 85.228 114.336 86.404 114.336 87.964V91.096H117.576V97H104.472V91.096H106.056V82.888H104.472V76.984H114.336V79.612C115.008 78.604 115.776 77.836 116.64 77.308C117.504 76.756 118.548 76.48 119.772 76.48ZM125.112 75.004V68.992H132.456V75.004H125.112ZM123.384 97V91.096H124.968V82.888H123.384V76.984H133.248V91.096H134.832V97H123.384ZM146.558 97.504C143.15 97.504 140.486 96.616 138.566 94.84C136.646 93.04 135.686 90.424 135.686 86.992C135.686 83.56 136.646 80.956 138.566 79.18C140.486 77.38 143.15 76.48 146.558 76.48C150.014 76.48 152.69 77.392 154.586 79.216C156.482 81.016 157.43 83.608 157.43 86.992C157.43 90.424 156.47 93.04 154.55 94.84C152.63 96.616 149.966 97.504 146.558 97.504ZM146.558 91.096C147.254 91.096 147.77 90.916 148.106 90.556C148.466 90.172 148.646 89.584 148.646 88.792V85.192C148.646 84.4 148.466 83.824 148.106 83.464C147.77 83.08 147.254 82.888 146.558 82.888C145.862 82.888 145.334 83.08 144.974 83.464C144.638 83.824 144.47 84.4 144.47 85.192V88.792C144.47 89.584 144.638 90.172 144.974 90.556C145.334 90.916 145.862 91.096 146.558 91.096ZM180.284 91.096H181.832V97H173.012L169.304 90.088H168.44V97H158.576V91.096H160.16V74.896H158.576V68.992H168.44V83.608H169.304L173.768 76.984H181.364V82.888H179.888L176.828 86.308L180.284 91.096ZM182.83 97V91.636L191.614 82.888H188.41V84.184H183.046V76.984H201.946V82.132L193.378 91.096H196.834V89.08H202.27V97H182.83ZM203.291 97V91.636L212.075 82.888H208.871V84.184H203.507V76.984H222.407V82.132L213.839 91.096H217.295V89.08H222.731V97H203.291Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddd_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 46H129V61.4628H98.1325V97H75.8675V61.4628H45V46Z",
    fill: "url(#paint0_linear_0_1)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 46H129V61.4628H98.1325V97H75.8675V61.4628H45V46Z",
    stroke: "black",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddd_0_1",
    x: 40.5,
    y: 45.5,
    width: 93,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_0_1",
    result: "effect2_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_0_1",
    result: "effect3_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_0_1",
    result: "effect4_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 87,
    y1: 46,
    x2: 87,
    y2: 97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#F12330"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriokzzlohgo);
export default __webpack_public_path__ + "static/media/triokzzlohgo.cb5f14d81a1f61ad20cbe991cbb6c26c.svg";
export { ForwardRef as ReactComponent };